import { combineReducers } from 'redux';
import { ActionType } from 'typesafe-actions';

import { betsActions } from './actions';
import {
  BETS_FAILURE,
  BETS_REQUEST,
  BETS_SUCCESS,
  CREATE_BET_REQUEST,
  CREATE_BET_FAILURE,
  CREATE_BET_SUCCESS,
} from '../../constants/bets';
import { UnlockedTipData } from '../tips/reducer';

export type BetsState = {
  requested: boolean;
  data: UnlockedTipData[];
  isLoading: boolean;
  error: string | null;
};
export type BetsActions = ActionType<typeof betsActions>;

export const betsReducer = combineReducers<BetsState, BetsActions>({
  requested: (state = false, action) => {
    switch (action.type) {
      case BETS_REQUEST:
      case CREATE_BET_REQUEST:
        return true;
      case CREATE_BET_SUCCESS:
      case CREATE_BET_FAILURE:
      case BETS_SUCCESS:
      case BETS_FAILURE:
        return false;
      default:
        return state;
    }
  },
  data: (state = [], action) => {
    switch (action.type) {
      case BETS_SUCCESS:
        return action.payload.tips;
      case CREATE_BET_SUCCESS:
        return action.payload;
      default:
        return state;
    }
  },
  isLoading: (state = false, action) => {
    switch (action.type) {
      case BETS_REQUEST:
      case CREATE_BET_REQUEST:
        return true;
      case CREATE_BET_SUCCESS:
      case CREATE_BET_FAILURE:
      case BETS_FAILURE:
      case BETS_SUCCESS:
        return false;

      default:
        return false;
    }
  },
  error: (state = null, action) => {
    switch (action.type) {
      case BETS_FAILURE:
      case CREATE_BET_FAILURE:
        return action.payload.message || action.payload.detail;
      default:
        return null;
    }
  },
});
